// import ContactSupport from "@/components/smart/modals/ContactSupport";
import Modal from "@/classes/Modal";
import Vue from "vue";

const modals = {
  namespaced: true,
  state: {
    stack: [],
    index: 1,
  },
  mutations: {
    ADD_MODAL(state, payload) {
      state.index += 1;
      Vue.set(state, "stack", [...state.stack, payload]);
    },
    REMOVE_MODAL(state, payload) {
      let newStack = state.stack.slice();
      const foundIndex = payload.id
        ? newStack.findIndex((val) => val.id === payload.id)
        : newStack.findIndex((val) => val.template === payload.template);
      newStack.splice(foundIndex, 1);
      Vue.set(state, "stack", [...newStack]);
    },
    CLEAR_ALL(state) {
      Vue.set(state, "stack", []);
    },
  },
  actions: {
    open({ commit, state }, payload) {
      let added = payload;
      if (!(payload instanceof Modal)) {
        added = new Modal({ ...payload, id: state.index });
      }
      commit("ADD_MODAL", added);

      return added;
    },
    close({ commit }, payload) {
      let removed = payload;
      if (!(payload instanceof Modal)) {
        removed = new Modal(payload);
      }

      removed.close();

      commit("REMOVE_MODAL", removed);
    },
    confirm({ commit }, payload) {
      let removed = payload;
      if (!(payload instanceof Modal)) {
        removed = new Modal(payload);
      }

      removed.confirm();

      commit("REMOVE_MODAL", removed);
    },
    openContactSupport() {
      console.log("opening contact");
      // dispatch("open", {
      //   template: ContactSupport,
      // });
    },
  },
  getters: {
    getStack: (state) => state.stack,
    topModal: (state) => state.stack.sort((a, b) => (a.order > b.order ? 1 : -1))[0] || false,
  },
};

export default modals;
